import { render, staticRenderFns } from "./CompTableBar.vue?vue&type=template&id=38ba1642"
import script from "./CompTableBar.vue?vue&type=script&lang=js"
export * from "./CompTableBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports